import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "../../Common/Tables/BaseTable";
import OvertredelseskoderMiljogebyrUpdateModal from "./UpdateModals/OvertredelseskoderMiljogebyrModal";

import { getOvertredelseskoderMiljogebyr } from "../../../actions/overtredelseskoderMiljogebyrActions";
import * as title from "../../../constants/titles";

export default function OvertredelseskoderMiljogebyrList({
  authorizedToCreateAndEdit,
}) {
  const dispatch = useDispatch();
  const overtredelseskoderMiljogebyr = useSelector(
    (state) => state.overtredelseskoderMiljogebyr,
  );
  const overtredelseskoderMiljogebyrAktivStatus = useSelector(
    (state) =>
      state.forms.grunndataFilterForm.overtredelseskoderMiljogebyrAktivStatus,
  );

  useEffect(() => {
    document.title = title.overtredelseskoderMiljogebyr;
    dispatch(getOvertredelseskoderMiljogebyr());
  }, [dispatch]);

  const headerRow = [
    "Overtredelseskode",
    "Paragraf",
    "Del",
    "Beløp",
    "Kort tekst",
    "Lang tekst",
    "Arkivkode",
    "Status",
    "",
  ];

  if (!overtredelseskoderMiljogebyr) return null;

  const filtered = overtredelseskoderMiljogebyr.filter(
    (okm) =>
      okm.aktiv === overtredelseskoderMiljogebyrAktivStatus ||
      overtredelseskoderMiljogebyrAktivStatus === null,
  );

  return (
    <Table
      id="overtredelseskoderMiljogebyr-liste"
      className="table-wrapper-horizontal-scroll-white-space-normal"
      defaultStyle
      striped
      headerRow={headerRow}
    >
      <tbody>
        {map(filtered, (okm) => (
          <tr key={`overtredelseskoderMiljogebyrTableBodyTr${okm.id}`}>
            <td>{okm.id}</td>
            <td>{okm.paragraf}</td>
            <td>{okm.del}</td>
            <td>{okm.belop}</td>
            <td>{okm.kortTekst}</td>
            <td>{okm.langTekst}</td>
            <td>{okm.arkivKode}</td>
            <td>{okm.aktiv === true ? "Aktiv" : "Deaktivert"}</td>
            <td>
              {authorizedToCreateAndEdit && (
                <OvertredelseskoderMiljogebyrUpdateModal
                  overtredelseskoderMiljogebyr={okm}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
